import { render, staticRenderFns } from "./HistoryFundsTable.vue?vue&type=template&id=94e72df8&"
import script from "./HistoryFundsTable.vue?vue&type=script&lang=ts&"
export * from "./HistoryFundsTable.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryFundsTable.vue?vue&type=style&index=0&id=94e72df8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports